import '../FormInput/formInput.scss';
import './formSelect.scss';

export const FormSelectTemplate = (model) => {
	const { display_name, attribute_type, inputWithSelect = false } = model;

	/* html */
	const labelHtml = display_name ? `<label class="engt-form-label">${display_name}</label>` : '';

	/* html */
	const formInputHtml = `<div style="${inputWithSelect ? '' : 'margin-top:10px;'}">
                                 ${labelHtml}
                                <form-select></form-select>
                        </div>`;

	return formInputHtml;
};
